import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OriginalLP from './pages/OriginalLP';
import MysteryLP from './pages/MysteryLP';
import ClinicaLP from './pages/ClinicaLP';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<OriginalLP />} />
        <Route path="/oferta-exclusiva" element={<MysteryLP />} />
        <Route path="/consultorio" element={<ClinicaLP />} />
      </Routes>
    </Router>
  );
}

export default App;
